import { useState } from "react";

import Typography from "../Typography/Typography";
import styles from "./TextInput.module.scss";

const TextInput = (props) => {
	const {
		type = "text",
		onChange = () => {},
		className,
		placeholder,
		label,
		setError = () => {},
		error = false,
		pattern = null,
		formatter = (value) => value,
		disabled = false,
		readOnly = false,
		value: controlledValue,
		...rest
	} = props;

	const isControlled = controlledValue !== undefined;
	const [formattedValue, setFormattedValue] = useState(() =>
		isControlled ? String(controlledValue ?? "") : "",
	);

	const displayValue = isControlled
		? String(controlledValue ?? "")
		: formattedValue;

	const handleChange = (value) => {
		if (readOnly || disabled) {
			return;
		}
		let formatted = value;

		if (formatter) {
			formatted = formatter(value);
		} else if (pattern) {
			formatted = value.replace(pattern, "");
		}

		if (!isControlled) {
			setFormattedValue(formatted);
		}
		onChange(formatted);
	};

	return (
		<div className={`${styles.textInputContainer} ${className}`}>
			<Typography bold variant="h6">
				{label}
			</Typography>
			<input
				{...rest}
				className={`${styles.textInput} ${
					error && styles.textInputError
				} ${readOnly ? styles.textInputReadOnly : ""}`}
				placeholder={placeholder}
				type={type}
				value={displayValue}
				readOnly={readOnly}
				onFocus={(e) => {
					if (!readOnly) {
						e.target.placeholder = "";
					}
					setError(false);
				}}
				onBlur={(e) => (e.target.placeholder = placeholder)}
				onChange={(e) => handleChange(e.target.value)}
				disabled={disabled}
			/>
		</div>
	);
};

export default TextInput;
